// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fBkuj","titleShimmer":"styles_titleShimmer__OO0xp","cardsContainer":"styles_cardsContainer__xd0uo","cardShimmer":"styles_cardShimmer__S3nWS"};